import monetize, { demonetize } from '@formatters/monetize';

import { COMBINED_REGEXP } from './name';

// SOURCE:
// https://github.com/jonschlinkert/is-number
function number(value) {
  if (typeof value === 'number') {
    return value - value === 0;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    // eslint-disable-next-line no-restricted-properties
    return Number.isFinite ? Number.isFinite(+value) : window.isFinite(+value);
  }

  return false;
}

export function parse(key, value) {
  if (/_cents$/.test(key) || monetize(value) === value || number(value)) {
    if (value[0] === '0') {
      return value.replace(/\D/g, '');
    }

    if (String(parseFloat(value, 10)) === value) {
      return value;
    }

    return demonetize(value);
  }

  if (['true', 'false'].includes(value)) {
    return value === 'true';
  }

  return value;
}

export default function data(form, planter) {
  const parsed = new FormData(form);
  const original = Object.fromEntries(Array.from(parsed.keys(), (name) => {
    const value = parsed.getAll(name);
    return [name, value.length > 1 || (planter.properties.value[name]?.type === 'checkbox') ? value : value.pop()];
  }));

  function reducer(reduced, key) {
    if (COMBINED_REGEXP.test(key)) {
      return reduced;
    }

    let current = reduced;
    const nested = key.replace(/\]/g, '').split('[');
    const field = nested.pop();

    for (let i = 0, l = nested.length; i < l; i += 1) {
      if (!current[nested[i]]) {
        const next = nested[i + 1];
        const array = next && String(parseInt(next, 10)) === next;

        current[nested[i]] = array ? [] : {};
      }

      current = current[nested[i]];
    }

    current[field] = parse(field, original[key]);

    return reduced;
  }

  return Object.keys(original).reduce(reducer, {});
}
